import Vue from 'vue'
import AppAvatar from '../components/shared/AppAvatar.vue'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import AppModal from '../components/shared/AppModal'
import AppDropdown from '../components/shared/AppDropdown'
import AppAssignUser from '../components/setters/AppAssignUser'
import AppAssignUserMultiple from '../components/setters/AppAssignUserMultiple'
import VueMultiselect from '../components/wrappers/VueMultiselect.vue'
import {LicenseManager} from 'ag-grid-enterprise'
import {AgGridVue} from 'ag-grid-vue'

LicenseManager.setLicenseKey('CompanyName=Zudello Pty Ltd,LicensedApplication=Zudello,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-013418,ExpiryDate=4_February_2022_[v2]_MTY0MzkzMjgwMDAwMA==8b865103e32a1537809a1ce21264580a')

Vue.component('AgGridVue', AgGridVue)
Vue.component('avatar', AppAvatar)
Vue.component('VueNumberInput', VueNumberInput)
Vue.component('AppModal', AppModal)
Vue.component('AppDropdown', AppDropdown)
Vue.component('AppAssignUser', AppAssignUser)
Vue.component('AppAssignUserMultiple', AppAssignUserMultiple)
Vue.component('multiselect', VueMultiselect)
